import React from 'react'

function Adminservices() {
    return (
        <div className="adminServices_container">
            <h1>Services Page</h1>
        </div>
    )
}

export default Adminservices
